const FALLBACK_BUCKET = 'redbox-gbp-img-test';

export const s3Bucket = (() => {
  const bucket = import.meta.env.VITE_AWS_S3_BUCKET;
  
  if (!bucket) {
    console.warn(
      'Invalid s3 bucket configuration in env file, falling back to production bucket for AWS_S3_BUCKET:',
      import.meta.env.VITE_ENVIRONMENT_NAME_LOWERCASE
    );
    return FALLBACK_BUCKET;
  }
  
  return bucket;
})();
